/**
 * Il y a un système de chapitres à trois endroits sur le site:
 * * block Sommaire ;
 * * block Slider (version chapitrée, présente sur les pages Parcours Thématique ;
 * * block Slider (version chapitrée, présente sur les pages Ressources (dans certaines conditions))
 * 
 * Chaque chapitrage est un slider, et le clic sur un chapitre récupère le contenu du <template> le plus proche 
 * pour remplacer le contenu du <output> le plus proche.
 * 
 * The Expandable lib was not use, in favor of <output>'s children replacement based on <template>s content
 * 
 * 
 * 
 * You can optionally apply a callback right before the replacement, and right after
 */
/* import Swiper core, modules, and css */
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules'; // import Swiper modules (if needed). Full list available here: https://swiperjs.com/swiper-api#modules
import { toggleSwiperLock } from './toggleSwiperLock'
 
const initChaptersSwiper = (chaptersSwiperNode) => {
    // console.log('initiating chapters swiper with', chaptersSwiperNode)
    const swiper = new Swiper(chaptersSwiperNode, {
        slidesPerView: 'auto',
        modules: [Navigation, FreeMode],
        
        navigation: {
            prevEl: '[data-swiper-prev]',
            nextEl: '[data-swiper-next]',
        },
        
        spaceBetween: 0,
        
        on: {
            init: function(swiper) {
              return toggleSwiperLock(swiper)
            },
            resize: function(swiper) {
              return toggleSwiperLock(swiper)
            },
            /*progress: function(swiper, progress) {
              console.log(progress)
            },*/
        },
        
        // preventClicks: true,
        slideToClickedSlide: true,
        freeMode: true,
    })
    // console.log('chapters\' swiper initiated')
}

export const useChapters = (node = null, chaptersSwiperNode = null, onBeforeChapterChange = null, onAfterChapterChange = null) => {
    if (node === null) return
    if (chaptersSwiperNode === null) return
    
    // else
    // console.log('useChapters')
    onBeforeChapterChange = (typeof onBeforeChapterChange === 'function') ? onBeforeChapterChange : function() {};
    onAfterChapterChange = (typeof onAfterChapterChange === 'function') ? onAfterChapterChange : function() {};
    
    initChaptersSwiper(chaptersSwiperNode)
      
    const chaptersArr = [ ...node.querySelectorAll('[data-chapter]') ]
    if (chaptersArr.length < 2) return
    
    // console.log('there is more than 1 chapter')
    
    // else
    chaptersArr.forEach(_$tab => {
        _$tab.addEventListener('click', (e) => {
            // set tabs status
            const $formerTab = node.querySelector('[data-chapter][aria-selected="true"]')
            const $newTab = e.target.closest('[data-chapter]')
            if ($formerTab === $newTab) return
            
            // else
            onBeforeChapterChange($formerTab)
            
            $formerTab.ariaSelected = 'false'
            $newTab.ariaSelected = 'true'
            // clone the template
            const $template = node.querySelector(`#${$newTab.id}__template`)
            console.log('found template:', $template)
            const clone = document.importNode($template.content, true);
            // inject
            const $output = node.querySelector('output')
            $output.replaceChildren(clone)
            $output.parentElement.swiper.setProgress(0) // fixes a case where, if a large slider is translated, and then we change chapter to a smaller one, the swiper-wrapper would still be translated.
            
            onAfterChapterChange($newTab)
        })
    })
}